// Windows Ready Handler
(function ($) {
	$(document).ready(function () {});
})(jQuery);
